import { FC } from 'react';

import AtriumNorth from '../../../../../../../assets/icons/shapes/atrium/atrium-1.svg?react';
import AtriumEast from '../../../../../../../assets/icons/shapes/atrium/atrium-2.svg?react';
import AtriumSouth from '../../../../../../../assets/icons/shapes/atrium/atrium-3.svg?react';
import AtriumWest from '../../../../../../../assets/icons/shapes/atrium/atrium-4.svg?react';
import { Himmelretning } from '../../../../../utils/registerEnums';

import { ShapeProps } from './types';

export const Atrium: FC<ShapeProps> = ({ direction }) => {
  switch (direction) {
    case Himmelretning.Nord:
      return <AtriumNorth />;
    case Himmelretning.Ost:
      return <AtriumEast />;
    case Himmelretning.Sor:
      return <AtriumSouth />;
    case Himmelretning.Vest:
      return <AtriumWest />;

    default:
      return <AtriumNorth />;
  }
};
